export enum PendingWithdrawalTooltip {
  returnAmount = 'return',
  remainAmount = 'remain',
}
